
export const dataThes = [

    {
      id: 1,
      name: "Thé Noir Nature",
      searchTerm: "noir",
      price: 27.25,
      image: './image/noir1.jpg',
      ingredients : "Thé noir Rukeri",
      description : "Afin d'empêcher les feuilles de se casser, elles ne sont déplacées que de façon minime pendant le processus de flétrissement. Notre thé est composé de longues feuilles raides, mi-brunes et leur goût est légèrement épicé avec une agréable note d'agrumes.",
      showMore : false,
    },

    {
      id: 2,
      name: "Thé Vert Sencha",
      searchTerm: "vert",
      price: 21.75,
      image: './image/sencha.jpg',
      ingredients : "Thé vert Sencha de Chine",
      description : "Le thé vert Sencha est le thé le plus courant au Japon. Afin d'arrêter l'oxydation des feuilles de thé, elles sont soumises à un rapide bain de vapeur, puis elles sont roulées et séchées. Lorsqu'il est produit à partir de théiers japonais, son infusion est très verte et assez amère. Ici, l'utilisation de thé de chine adoucis sont goût, diminue l'amertune et lui donne une tasse vert-jaune.",
      showMore : false,
    },
    {
      id: 3,
      name: "Thé Vert Gunpowder",
      searchTerm: "vert",
      price: 25.25,
      image: "./image/gunpowder.jpg",
      ingredients : "Thé vert Gunpowder.",
      description : "Le gunpowder est l’un des thés les plus populaires en Chine. La forme typique de « curling » est obtenue en mouillant plusieurs fois les feuilles lors du séchage afin de ralentir cette phase. Cette version BIO est riche en caféine et peut être infusée plusieurs fois.",
      showMore : false,
    },
    {
      id: 4,
      name: "Thé à la Menthe Verte",
      searchTerm: "vert",
      price: 31.75,
      image: "./image/menthe.jpg",
      ingredients : "Thé vert Sencha, Menthe Verte (21%).",
      description : "Un grand classique: le thé vert à la menthe verte.",
      showMore : false,
    },
    {
      id: 5,
      name: "Plaisir Fruit de la Passion",
      searchTerm: "vert",
      price: 31.75,
      image: "./image/passion.jpg",
      ingredients : "Thé vert (46%), arôme naturel, betterave, fleurs de souci, écorces d'oranges.",
      description : "Notre Plaisir Fruits de la Passion vous apportera un plaisir exotique grâce à son goût fruit de la passion.",
      showMore : false,
    },
    
    {
      id: 6,
      name: "Infusion Citron Gingembre",
      searchTerm: "detox",
      price: 29.50,
      image: './image/citrongeng.jpg',
      ingredients : "Gingembre, pomme, coquilles d'églantier, verveine, pétales d'hibiscus, zeste de citron, arômes naturels.",
      description : "La combinaison de ces deux saveurs n'a plus à faire ses preuves. Les notes citronnées donnent le ton initial. S'ensuit une séquence de gingembre légèrement épicé pour finir en beauté.",
      showMore : false,
    },
    {
        id: 7,
        name: "Rooibos Fleuri",
        searchTerm: "rouge",
        price: 32.75,
        image: './image/fleuri.jpg',
        ingredients : "Rooibos, hibiscus, fleurs de souci, rose et fleurs de bleuet.",
        description : "Notre Rooibos Fleuri se compose d'un assortiment de fleurs sur une base de Rooibos. Ses couleurs vives et son goût chaleureux apporteront de la chaleur en toute saison.",
        showMore : false,
      },
    {
      id: 8,
      name: "Thé Vert Sencha Ananas Mangue",
      searchTerm: "vert",
      price: 33.75,
      image: './image/ananasman.jpg',
      ingredients : "Thé vert (93%), morceaux d'ananas, arôme naturel, cubes de mangue, pétales de tournesol, fleurs de souci.",
      description : "L'été, le soleil, l'ananas, la mangue ! Quelle est la première chose que ces mots vous inspirent? Peut-être les vacances, la plage, les palmiers ? Notre première pensée fut la plage, une plage paradisiaque. Nous avons donc créé un mélange aux saveurs tropicales. L'ananas mûr et vif se marie avec la mangue dorée et sucrée.  Associés à notre thé vert, l'expérience gustative est tout simplement unique. Un plaisir à la fois chaud et froid.",
      showMore : false,
    },
    {
      id: 9,
      name: "Thé Noir Assam",
      searchTerm: "noir",
      price: 26.50,
      image: './image/assam.jpg',
      ingredients : "Thé noir Assam.",
      description : "L'Assam GBOP (Golden Broken Orange Pekoe) est un thé noir produit dans la vallée d’Assam, au sud de la rivière Bramaputhra.",
      showMore : false,
    },
    {
        id: 10,
        name: "Rooibos Nature",
        searchTerm: "rouge",
        price: 24.25,
        image: './image/roibnature.jpg',
        ingredients : "Rooibos.",
        description : "Le Rooibos est issu d'un arbuste dont le nom signifie 'buisson rouge' en afrikaans. Ce buisson ne pousse qu'en Afrique du Sud car il nécessite un climat et un sol bien particulier. Contrairement à son appelation de 'thé rouge', ce n'est par un thé et il ne contient pas de caféine. Le rooibos a une saveur plutôt douce même sans ajout de sucre, son infusion est rouge - brun.",
        showMore : false,
      },
      {
        id: 11,
        name: "Rooibos Myrtille",
        searchTerm: "rouge",
        price: 37.00,
        image: './image/myrtille.jpg',
        ingredients : "Rooibos, honeybush, fenouil, arôme naturel, fleurs de bleuet.",
        description : "Des fleurs de bleuet rayonnantes attirent votre attention, l’honeybush et le fenouil soulignent la douceur de ce mélange bien équilibré et apportent une saveur unique à ce thé.",
        showMore : false,
      },
  {
      id: 12,
      name: "Thé Noir Sencha",
      searchTerm: "noir",
      price: 24.25,
      image: './image/noirsencha.jpg',
      ingredients : "Thé noir Sencha de Chine.",
      description : "Issu de la province de Zhejiang, cette spécialité est obtenue suivant le même procédé de fabrication que le thé vert sencha classique. Afin de devenir un thé noir, il est fermenté et torréfié. Ce thé se distingue par sa note grillée, une fine amertune tout en restant doux.",
      showMore : false,
    },
    {
        id: 13,
        name: "Infusion Agrume",
        searchTerm: "detox",
        price: 30.50,
        image: './image/agrumes.jpg',
        ingredients : "Morceaux de pomme, fleurs d'hibiscus, écorce d'orange, feuilles de framboise et d'eucalyptus, arôme naturel de citronnelle.",
        description : "Cette création accueille la douceur fruitée des morceaux de pomme et une touche de fraîcheur des feuilles d'eucalyptus, de la citronnelle et une nuance d'hibiscus. Une composition absolument parfaite.",
        showMore : false,
      },
      {
        id: 14,
        name: "Détox Feu du Dragon",
        searchTerm: "detox",
        price: 37.00,
        image: './image/dragon.jpg',
        ingredients : "Thé vert Sencha, hibiscus, arôme naturel, China White Monkey, pomme, écorces de citron, poivre rose, groseille.",
        description : "Ce Feu du Dragon à la saveur pomme-groseille. C'est un mélange aussi bon qu'énergisant.",
        showMore : false,
      },
    {
      id: 15,
      name: "English Breakfast",
      searchTerm: "noir",
      price: 26.50,
      image: './image/breakfast.jpg',
      ingredients : "Thé noir Assam, thé noir de Ceylan.",
      description : "L'English breakfast broken est un mélange de thés noirs originaires des régions de Assam et Ceylan. Sa liqueur dorée est caractérisée par iune saveur très aromatique. Sa consommation est particulièrement appropriée le matin.",
      showMore : false,
    },
    {
        id: 16,
        name: "Detox Morning Boost",
        searchTerm: "detox",
        price: 34.75,
        image: "./image/boost.jpg",
        ingredients : "Thé vert (92%), arôme naturel, écorce de cynorhodon, carthame, fleurs d'hibiscus, fleurs de souci, morceaux de pomme, écorce d'orange",
        description : "Ce mélange de thé combine différentes saveurs naturelles de fruits exotiques. Des arômes de pamplemousse, d'orange et de mangue se rejoignent pour former cette création de thé fruité, acidulé et juteux. Saveurs Orange Pamplemousse.",
        showMore : false,
      },
    {
      id: 17,
      name: "Thé Noir Orange Sanguin",
      searchTerm: "noir",
      price: 29.50,
      image: './image/orange.jpg',
      ingredients : "Thé noir (92%), écorce d'orange, arôme naturel, carthame.",
      description : "Ce doux mélange de thé noir de Chine et de Ceylan vous rappellera les Caraïbes. Vous aurez une pensée pour les chaudes soirées d'été dans le Sud. Votre imagination n'a pas de limites lorsque vous dégustez cette boisson rafraîchissante, acidulée et fruitée!",
      showMore : false,
    },
    {
      id: 43,
      name: "Thé Noir Jinjing",
      searchTerm: "noir",
      price: 31.75,
      image: './image/jinjing.jpg',
      ingredients : "Thé noir Jinjing.",
      description : "Ce Jinjing est un thé noir originaire de la vallée de Jinjing en Chine. Il a un arôme doux et très plaisant.",
      showMore : false,
    },
    {
        id: 18,
        name: "Rooibos Fruits Rouges",
        searchTerm: "rouge",
        price: 37.00,
        image: './image/fruitsrg.jpg',
        ingredients : "Rooibos, raisin, baie de sureau, arôme naturel, fraise, framboise, groseille, cassis.",
        description : "Notre corbeille fruitée propose une double base de rooibos et de raisin qui met parfaitement en valeur les fruits rouges et les baies sauvages.",
        showMore : false,
      },
    {
        id: 19,
        name: "Détox Beautea Queen",
        searchTerm: "detox",
        price: 40.00,
        image: './image/queen.jpg',
        ingredients : "Thé vert Sencha, menthe, gingembre, baies de goji, arôme naturel, curcuma, morceaux de pomme, fleurs de sureau, menthe poivrée, grenade, pétales de rose.",
        description : "Ce Beautea Queen à la saveur délicate de grenade-menthe se compose de thé vert Sencha, de menthe, de gingembre, de baies de goji, de curcuma, de morceaux de pomme, de sureau, de menthe poivrée,  de grenade, de pétales de rose.",
        showMore : false,
      },
    {
      id: 20,
      name: "Thé Noir Earl Grey",
      searchTerm: "noir",
      price: 31.75,
      image: './image/earl.jpg',
      ingredients : "Thé noir Ceylan, thé noir Assam, arôme naturel de Bergamote.",
      description : "Earl Grey est un mélange de thés noirs originaires de Ceylan, d'Assam associés à de la bergamote qui en fait un Earl Grey d'un finesse et d'un goût inimitable.",
      showMore : false,
    },
    {
      id: 21,
      name: "Thé Noir à la Cannelle ",
      searchTerm: "noir",
      price: 32.75,
      image: './image/canelle.jpg',
      ingredients : "Thé noir (90%), morceaux de cannelle, arôme naturel.",
      description : "Le thé à la cannelle est un classique indissociable de Noël, particulièrement apprécié des amateurs. Notre mélange de Ceylan, enrichi de cannelle broyée, révèle son goût parfaitement équilibré grâce à la saveur expressive de cannelle. Un mélange simple mais toujours aussi parfait.",
      showMore : false,
    },
    {
      id: 22,
      name: "Thé Noir Fruits Rouges",
      searchTerm: "noir",
      price: 37.75,
      image: './image/noirfruitsrg.jpg',
      ingredients : "Thé noir, arômes naturels, pétales de bleuet, morceaux de framboise, myrtilles, morceaux de fraise.",
      description : "Notre thé au Fruits Rouges bio est un mélange de thés noirs de la région de Assam en Inde du sud à la saveur fruits rouges.",
      showMore : false,
    },
    {
        id: 23,
        name: "Rooibos Citron",
        searchTerm: "rouge",
        price: 37.00,
        image: './image/citron.jpg',
        ingredients : "Rooibos, arôme naturel, écorces de citron, souci, fleurs de bleuet.",
        description : "Notre Rooibos Citron Bio propose un mélange de saveurs citron, fruits de la passion, vanille qui se marient idéalement à l'infusion du rooibos.",
        showMore : false,
      },
    {
        id: 24,
        name: "Détox Ayurveda Kapha",
        searchTerm: "detox",
        price: 37.75,
        image: './image/kapha.jpg',
        ingredients : "Fenouil, mélisse, feuilles de mûre, coriandre moulue, fleurs de bleuet, cardamome, chili.",
        description : "L'Ayurveda est une forme de médecine traditionnelle originaire d'Inde. Nos tisanes ayurvédiques s'inspirent de ces méthodes ancestrales. Les vertus de ces tisanes dépendent de leurs ingrédients. Nous conseillons une consommation de 6 grammes par jours infusés dans 400 à 500 ml.",
        showMore : false,
      },
    {
      id: 25,
      name: "Thé à la Rose",
      searchTerm: "noir",
      price: 40.00,
      image: './image/rose.jpg',
      ingredients : "Thé noir Assam, pétales de rose (2%), arôme naturel.",
      description : "Le Rose est un thé noir de la région d'Assam en Inde du sud complété de pétales de rose (2%) et d'arôme naturel. l a une saveur à la fois prononcée et délicate de rose.",
      showMore : false,
    }
    ,
    {
      id: 26,
      name: "Paradis Exotique",
      searchTerm: "noir",
      price: 38.00,
      image: './image/paradise.jpg',
      ingredients : "Thé noir Assam, thé vert Sencha, arôme naturel, papaye, morceaux de mangue, fleurs de souci, fleurs de bleuet, pétales de rose.",
      description : "Paradis exotique est un mélange de thés noirs originaires de la région de Assam et de thés verts Sencha de Chine associé à des saveurs de fruits de la passion et papaye, de morceaux de mangue. Le mélange comprend également des fleurs de souci et des fleurs de bleuet ainsi que des pétales de rose qui lui donnent un goût floral.",
      showMore : false,
    },
    {
        id: 27,
        name: "Rooibos Exotique",
        searchTerm: "rouge",
        price: 37.00,
        image: './image/roexo.jpg',
        ingredients : "Rooibos, écorces d'orange, arôme naturel, banane (banane, huile de coco, sucre de canne, miel), fleurs de souci, papaye, morceaux de mangue, pétales de rose*, abricot, fleurs de bleuet.",
        description : "Notre rooibos exotique propose des saveurs rassurantes.",
        showMore : false,
      },
    {
      id: 28,
      name: "Thé de Noël",
      searchTerm: "noel",
      price: 36.00,
      image: './image/noel.jpg',
      ingredients : "Thé noir Assam, écorces d'orange, pomme, bâtons de cannelle, arôme naturel, pétales de rose, cardamome.",
      description : "Ce thé de Noel est un thé noir de la région de Assam en Inde du sud à la saveur orange cannelle. Il comprend des écorces d'orange, des bâtons de cannelle des arômes naturels, des pétales de rose et de la cardamome.",
      showMore : false,
    }
    ,
    {
      id: 29,
      name: "Cocktail maison pour l'hiver",
      searchTerm: "noel",
      price: 36.00,
      image: './image/cocktail.jpg',
      ingredients : "Thé noir Assam, bâtons de cannelle, citronnelle, écorces d'orange, clous de girofle, pétales de rose, cardamome.",
      description : "Ce Cocktail est un thé noir issu de la région de Assam en Inde du sud associé à des bâtons de cannelle, de la citronelle, des écorces d'orange, des clous de girofle, des pétales de rose et de la cardamone. C'est un thé particulièrement adapté en hiver.",
      showMore : false,
    },
    {
        id: 30,
        name: "Mélange Maison",
        searchTerm: "rouge",
        price: 31.75,
        image: './image/maison.jpg',
        ingredients : "Rooibos, pomme, hibiscus, cynorhodon, carvi, fenouil, fleurs de bleuet.",
        description : "Le mélange maison est une infusion classique qui saura plaire au plus grand nombre. A la fois fruité et doux.",
        showMore : false,
      },
    {
        id: 31,
        name: "Rooibos Souvenir Estival",
        searchTerm: "rouge",
        price: 31.75,
        image: './image/estival.jpg',
        ingredients : "Rooibos, hibiscus, citronnelle, fleurs de souci.",
        description : "Le Rooibos Souvenir Estival Bio allie le goût acidulé de l'hibiscus avec la fraîcheur de la citronnelle le tout sur une base de Rooibos.",
        showMore : false,
      },
    {
      id: 32,
      name: "Morning Melody",
      searchTerm: "blanc",
      price: 39.00,
      image: './image/melody.jpg',
      ingredients : "Thé vert Sencha de Chine, Pai Mu Tan, fleurs de souci, arôme naturel, pétales de rose, fleurs de bleuet.",
      description : "Notre Morning Melody contient un mélange de thé vert Sencha et de Pai Mu Tan. Le thé vert Sencha est le thé le plus courant au Japon. Afin d'arrêter l'oxydation des feuilles de thé, elles sont soumises à un rapide bain de vapeur, puis elles sont roulées et séchées. Lorsqu'il est produit à partir de théiers japonais, son infusion est très verte et assez amère. Ici, l'utilisation de thé de chine adouci son goût et diminue l'amertume. Le Pai Mu Tan ou Bai Mu Dan est un thé blanc au goût frais, fruité et floral qui est produit en conservant la proportion d'un bourgeon pour deux feuilles.",
      showMore : false,
    }
    ,
    {
      id: 33,
      name: "Infusion Fantaisie Hivernale",
      searchTerm: "noel",
      price: 31.75,
      image: './image/fanta.jpg',
      ingredients : "Pomme, hibiscus, cynorhodon, écorces d'orange, gingembre (gingembre, sucre de canne), cannelle, arôme naturel, noix, cardamome, poivre noir, clou de girofle, pétales de rose, pop-corn.",
      description : "La fantaisie hivernale s'appuie sur un mélange classique acidulé de pomme / hibiscus / cynorhodon. La fantaisie est apportée par le gingembre et les pop-corn. Oui! Vous avez bien lu, du pop-corn. Les bâtons de cannelle sont là pour la touche hivernale.",
      showMore : false,
    }
    ,
    {
      id: 34,
      name: "Thé Blanc Pai Mu Tan",
      searchTerm: "blanc",
      price: 63.25,
      image: './image/paimu.jpg',
      ingredients : "Thé Blanc Pai Mu Tan",
      description : "Les feuilles sont cueillies à la main et ramassées sur de grands arbres entre le 15 mars et le 10 avril, s'il n'a pas plu et que les feuilles sont sèches. On récolte généralement le bourgeon terminal, duveteux, avec les deux premières jeunes pousses, aux grandes feuilles. Aucun bourgeon rosé n'est admis dans la récolte et les pousses ne doivent être ni trop longues ni trop courtes.",
      showMore : false,
    }
    ,
    {
      id: 35,
      name: "Yunnan Pu-Erh",
      searchTerm: "noir",
      price: 44.25,
      image: './image/puerh.jpg',
      ingredients : "Pu-Erh",
      description : "Il y a des siècles, ce thé était réservé aux Chinois les plus privilégiés et était toujours traditionnellement enterré dans le sol afin de développer un goût typique. Nous avons sélectionné ce thé très bien établi, de grande qualité. Il se caractérise par une feuille brun foncé et un goût fort, épicé-terreux.",
      showMore : false,
    }
    ,
    {
      id: 36,
      name: "Thé Fumé Lapsang Souchong",
      searchTerm: "noir",
      price: 48.50,
      image: './image/lapsang.jpg',
      ingredients : "Lapsang Souchong",
      description : "Ce Lapsang Souchong est un thé noir fumé avec des bois spéciaux qui lui confèrent un goût fumé très prononcé. Bien qu'il provienne des feuilles basses de l'arbre, le souchong est classé parmi les thés fins. Comparé aux autres thés noirs, sa période d'oxydation est relativement longue. Le lapsang souchong est un souchong qui a été séché, d'abord sur du bois de pin ou de cèdre, puis roulé et oxydé, et enfin séché de nouveau dans des paniers de bambou placés au-dessus d'un feu d'épicéa ou de cyprès, le pin est aussi parfois employé.",
      showMore : false,
    }
    ,
    {
      id: 37,
      name: "Temple Night",
      searchTerm: "blanc",
      price: 42.25,
      image: './image/temple.jpg',
      ingredients : "Thé vert Sencha de Chine, thé Chun Mee, thé blanc Pai Mu Tan, arôme naturel, Perles du Dragon, thé blanc Mao Feng, thé vert Pi Lo Chun, baie de sureau, pêche, framboise, fleurs de sureau, baies de goji, pétales de rose, souci, fleurs de bleuet.",
      description : "Le Temple Night est un mélange intéressant et très complémentaire de thés verts et blancs de Chine. Le Sencha et le Chun Mee se marient parfaitement avec le Pai Mu Tan. Des perles du Dragon (thé au jasmin) complètent ce mélange.",
      showMore : false,
    }
    ,
    {
      id: 38,
      name: "Thé Blanc Passion Provence",
      searchTerm: "blanc",
      price: 37.00,
      image: './image/provence.jpg',
      ingredients : "Thé blanc, thé vert, citronnelle, feuilles de romarin (5%), arôme naturel, écorces de citron (4%), feuilles de menthe, feuilles de groseille.",
      description : "Notre thé Passion Provence est un mélange de thé blanc et de thé vert. Le thé blanc de grande qualité s'allie parfaitement avec du thé vert, de la citronnelle, des feuilles de romarin et des écorces de citron qui lui donneront un goût frais.",
      showMore : false,
    }
    ,
    {
      id: 39,
      name: "Baume Spirituel",
      searchTerm: "detox",
      price: 28.50,
      image: './image/baume.jpg',
      ingredients : "Feuilles d'eucalyptus, citronnelle, morceaux de pomme, racines de réglisse, fleurs de souci.",
      description : "Positivité et charisme! Cette composition piquante et clarifiante vous apportera une légèreté rafraichissante. Reliez ce thé à un moment de bonheur et profitez de chaque gorgées.",
      showMore : false,
    }
    ,
    {
      id: 40,
      name: "Chai",
      searchTerm: "detox",
      price: 37.00,
      image: './image/chai.jpg',
      ingredients : "Morceaux de cannelle, anis, morceaux de gingembre, cardamome entière, fenouil, écorce de citron, pétales de rose.",
      description : "Le thé Chai est un must dans tout assortiment de thé. Les épices naturelles ne nécessitent aucun ajout d'arôme pour se révéler. L'infusion reçoit un corps merveilleux grâce aux épices séchées.",
      showMore : false,
    }
    ,
    {
      id: 41,
      name: "Oasis Rafraichissante",
      searchTerm: "detox",
      price: 30.50,
      image: './image/oasis.jpg',
      ingredients : "Thé vert (59%), morceaux de pomme, arôme naturel, flocons de noix de coco grillés, poudre de matcha (1%), chips de noix de coco, fleurs de mauve.",
      description : "L'idée de ce mélange de thé vert est de vous créer un lieu de paix et de réflexion. Les notes fruitées de pêche, les touches légèrement crémeuses de noix de coco s'associent à une pointe de poudre de Matcha vert qui complète ce mélange. L'oasis rafraîchissante invite à s'attarder et à profiter.",
      showMore : false,
    }
    ,
    {
      id: 42,
      name: "Infusion Eucalyptus",
      searchTerm: "detox",
      price: 29.50,
      image: './image/eucalypt.jpg',
      ingredients : "Citronnelle, feuilles d'eucalyptus, morceaux de pomme, écorce d'orange, chips de noix de coco grillées",
      description : "Extrait du livre de recettes secret d'un koala : au petit déjeuner, faites un mélange de fines herbes et ajoutez une portion de feuilles d'eucalyptus prélevées directement dans le lieu de vie d'un koala. Décorez avec de grosses chips de noix de coco grillées. La note typique de l'eucalyptus est mise en valeur dans le mélange d'herbes fraîches.",
      showMore : false,
    }
  ]
  
  export default dataThes;